(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fpf-media-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(section) {
      if (!section || section.dataset.fpfMediaReady) return;
      section.dataset.fpfMediaReady = '1';
      var dialog = section.querySelector('.fpf-media__dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      var img = document.createElement('img');
      dialog.appendChild(img);
      section.querySelectorAll('[data-fpf-media-src]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          img.src = btn.dataset.fpfMediaSrc;
          img.alt = btn.dataset.fpfMediaAlt || '';
          dialog.showModal();
        });
      });
      dialog.querySelector('.fpf-media__close').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    }
    function init(scope) { (scope || document).querySelectorAll('.fpf-media').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tower-commercial-quote"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(n) {
      return '$' + Math.round(n).toLocaleString('en-US');
    }
    function setup(root) {
      if (!root || root.dataset.tgQuoteReady) return;
      root.dataset.tgQuoteReady = '1';
      var inputs = root.querySelectorAll('.tg-quote__qty');
      var min = parseInt(root.dataset.min || '0', 10);
      function update() {
        var count = 0, subtotal = 0;
        inputs.forEach(function (input) {
          var q = Math.max(0, parseInt(input.value || '0', 10) || 0);
          count += q;
          subtotal += q * (parseFloat(input.dataset.price) || 0);
        });
        var c = root.querySelector('[data-tg-quote-count]'); if (c) c.textContent = count;
        var s = root.querySelector('[data-tg-quote-subtotal]'); if (s) s.textContent = money(subtotal);
        var cf = root.querySelector('[data-tg-quote-count-field]'); if (cf) cf.value = count;
        var sf = root.querySelector('[data-tg-quote-subtotal-field]'); if (sf) sf.value = subtotal > 0 ? money(subtotal) : '';
        var m = root.querySelector('[data-tg-quote-min]'); if (m) m.hidden = !(min > 0 && count > 0 && count < min);
      }
      inputs.forEach(function (input) { input.addEventListener('input', update); });
      update();
    }
    function init(scope) { (scope || document).querySelectorAll('[data-tg-quote]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
